import { render, staticRenderFns } from "./CalendarHeader.vue?vue&type=template&id=a5e874cc&lang=pug"
import script from "./CalendarHeader.vue?vue&type=script&lang=js"
export * from "./CalendarHeader.vue?vue&type=script&lang=js"
import style0 from "./CalendarHeader.vue?vue&type=style&index=0&id=a5e874cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports